import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { axiosErrorHandler, isConcurrentModificationError, showErrorNotification } from "../../../../swzutils";
import DebtorNoteAlert from "../debtors/DebtorNoteAlert";
const ConsignmentPatchCustomerRefModal = ({ open, consignment, onUpdated, onCancel }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (open && consignment) {
            form.setFieldValue("customerRef", consignment.customerRef);
        }
    }, [open, consignment]);
    const patchCustomerRef = (formValues) => {
        setLoading(true);
        axios.patch(`/admin/v1/consignments/${consignment.id}`, {
            customerRef: formValues.customerRef ? formValues.customerRef : '',
            version: consignment.version,
        })
            .then(response => onUpdated(response.data))
            .catch(error => {
            if (isConcurrentModificationError(error)) {
                showErrorNotification("The customer ref could not be updated. This is because another user has updated the same delivery.  Please refresh the delivery list and try again.");
            }
            else {
                axiosErrorHandler(error);
            }
        })
            .finally(() => setLoading(false));
    };
    return (_jsxs(Modal, { title: `${consignment?.consignmentRef}: Update Customer Ref`, open: open && !!consignment, okText: "Update", onOk: form.submit, onCancel: onCancel, confirmLoading: loading, destroyOnHidden: true, children: [_jsx(DebtorNoteAlert, { customerId: consignment?.customer?.id }), _jsx(Form, { form: form, onFinish: patchCustomerRef, layout: "vertical", initialValues: {
                    'customerRef': consignment?.customerRef,
                }, children: _jsx(Form.Item, { name: "customerRef", label: "Customer Reference", rules: [
                        { max: 50, message: 'Please limit the customer reference to 50 characters.' }
                    ], children: _jsx(Input, { maxLength: 50 }) }) })] }));
};
export default ConsignmentPatchCustomerRefModal;
